import { createStore, compose, applyMiddleware } from 'redux';
import promiseMiddleware from 'redux-promise';
import reducers from './../reducers';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(reducers, {}, 
    composeEnhancers(applyMiddleware(promiseMiddleware)));
const createHistory = require("history").createBrowserHistory;
const history = createHistory({ basename: '/' });

export { store, history };